import { render, staticRenderFns } from "./DialogStudies.vue?vue&type=template&id=73d0d956&"
import script from "./DialogStudies.vue?vue&type=script&lang=js&"
export * from "./DialogStudies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports